import { Module } from 'vuex'

// store
import { RootState } from '../../../store/state_models'

// services
import { LcPhoneService } from '../../../services/LCPhoneService'

export interface RegulatoryBundleStoreModule {
  loading: boolean
  regulatoryBundles: any[]
  bundleDetails: any
}

export const regulatoryBundle: Module<RegulatoryBundleStoreModule, RootState> = {
  namespaced: true,
  state: {
    loading: false,
    regulatoryBundles: [],
    bundleDetails: {},
    tableSpinner: false,
  } as RegulatoryBundleStoreModule,
  getters: {
    /* companyHasWallet: state => {
       return state.companyHasWallet
     }, */
  },
  mutations: {
    regulatoryBundles(state, payload) {
      state.regulatoryBundles = []
      state.regulatoryBundles = payload
    },
    tableSpinner(state, payload) {
      state.tableSpinner = payload
    },
  },
  actions: {
    reset({ commit }) {
      commit('loading', false)
      commit('regulatoryBundles', [])
      commit('bundleDetails', {})
      commit('tableSpinner', false)
    },
    async listAllBundles({ commit, rootState }) {
      try {
        commit('tableSpinner', true)
        const locationId = rootState?.locations.currentLocation.id as string
        const res = await LcPhoneService.listRegulatoryBundles(locationId)
        commit('regulatoryBundles', res)
        commit('tableSpinner', false)
        return res
      } catch (error) {
        commit('tableSpinner', false)
        throw error
      }
    },
    async submitAddressInformation(_, data: any) {
      try {
        const res = await LcPhoneService.submitAddressInformation(data)
        return res
      } catch (error) {
        throw error
      }
    },
    async createRegulatoryBundle(_, data: any) {
      try {
        const res = await LcPhoneService.createRegulatoryBundle(data)
        return res
      } catch (error) {
        throw error
      }
    },
    async createEndUser(_, data: any) {
      try {
        const res = await LcPhoneService.createEndUser(data)
        return res
      } catch (error) {
        throw error
      }
    },
    async listAddresses({ rootState }) {
      try {
        const locationId = rootState?.locations.currentLocation.id as string
        const res = await LcPhoneService.listAddresses(locationId)
        return res
      } catch (error) {
        throw error
      }
    },
    async submitRegulatoryBundle(_, data: any) {
      try {
        const res = await LcPhoneService.submitRegulatoryBundle(data)
        return res
      } catch (error) {
        throw error
      }
    },
    async attachDocuments(_, { locationId, data }: { locationId: string; data: any }) {
      try {
        const res = await LcPhoneService.attachDocuments(locationId, data)
        return res
      } catch (error) {
        throw error
      }
    },
    async deleteBundle(_, data: any) {
      try {
        const res = await LcPhoneService.deleteBundle(data)
        return res
      } catch (error) {
        throw error
      }
    },
    async deleteAddress(_, data: any) {
      try {
        const res = await LcPhoneService.deleteAddress(data)
        return res
      } catch (error) {
        throw error
      }
    },
    async getBundleDetails(_, data: any) {
      try {
        const res = await LcPhoneService.getBundleDetails(data)
        return res
      } catch (error) {
        throw error
      }
    },
    async getRejectionReason(_, data: any) {
      try {
        const res = await LcPhoneService.getRejectionReason(data)
        return res
      } catch (error) {
        throw error
      }
    },
  },
}
